import {Helmet} from '@dr.pogodin/react-helmet';

import {CreateServiceVehicleModal} from '@dms/features/service-vehicle-form';
import i18n from '@dms/i18n';
import {vehiclesRoutes} from '@dms/routes';
import {formatDocumentTitle} from '@dms/shared';

import {useNavigate} from 'shared/web';

export function CreateServiceVehicle() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>
          {formatDocumentTitle(
            i18n.t('entity.vehicle.labels.createServiceVehicle'),
            i18n.t('entity.vehicle.labels.pageTitle')
          )}
        </title>
      </Helmet>
      <CreateServiceVehicleModal
        onCreated={(vehicleId) => navigate(vehiclesRoutes.detail.replace(':id', vehicleId))}
        onDiscard={() => navigate(-1)}
      />
    </>
  );
}
